document.addEventListener("DOMContentLoaded", async () => {
	const { initAccordion } = await import("@utils/accordion");
	initAccordion();
});
